let Personal = {
    /**
     * Идентификатор пользователя в mindbox
     */
    mindboxUserId: null,
    /**
     * Баланс бонусного счёта пользователя (количество доступных баллов)
     */
    bonusBalance: null,
    /**
     * Флаг, обрабатывается ли сейчас авторизованный на сайте пользователь
     */
    isAuthUser: null,
    /**
     * Функция определяет идентификатор пользователя в mindbox
     */
    getMindboxUserId: function () {
        "use strict";

        return new Promise(function (resolve, reject) {
            // Сначала попробуем достать из куки
            const cookieMindboxUserId = BX.getCookie("BITRIX_SM_MINDBOX_USER_ID");

            if (!cookieMindboxUserId) {
                const userId = window.BX.message("USER_ID");

                if (userId) {
                    // Создаем экземпляр класса XMLHttpRequest
                    let request = new XMLHttpRequest();

                    let formData = new FormData();

                    formData.append("user_id", userId);

                    request.open(
                        "POST",
                        "/ajax/user/get_user_mindbox_id.php",
                        true
                    );

                    request.responseType = "json";

                    request.send(formData);

                    request.onload = function () {
                        if (request.readyState === 4 && request.status === 200) {
                            const jsonResponse = request.response;
                            if (!!jsonResponse && jsonResponse.hasOwnProperty("mindboxUserId")) {
                                if (jsonResponse.mindboxUserId) {
                                    Personal.mindboxUserId = jsonResponse.mindboxUserId;
                                    Personal.setMindboxUserId(jsonResponse.mindboxUserId);
                                }
                                resolve(Personal.mindboxUserId);
                            } else {
                                reject(new Error("Запрос выполнился, но не получено полезной нагрузки."));
                            }
                        } else {
                            // Запрос не выполнился
                            reject(new Error("Запрос не выполнился. " + request.status + ': ' + request.statusText));
                        }
                    };
                } else {
                    resolve(null);
                }
            } else {
                Personal.mindboxUserId = cookieMindboxUserId;
                resolve(Personal.mindboxUserId);
            }
        });
    },
    /**
     * Сохранение идентификатора пользователя в mindbox
     *
     * @param {Number} mindboxUserId Идентификатора пользователя в mindbox
     */
    setMindboxUserId: function (mindboxUserId) {
        "use strict";

        if (mindboxUserId > 0) {
            // Создаем экземпляр класса XMLHttpRequest
            let request = new XMLHttpRequest();

            let formData = new FormData();

            const userId = window.BX.message("USER_ID");
            formData.append("user_id", userId);
            formData.append("mindbox_user_id", mindboxUserId);

            request.open(
                "POST",
                "/ajax/user/set_user_mindbox_id.php",
                true
            );

            request.send(formData);
        }
    },
    /**
     * Функция запрашивает баланс бонусного счёта клиента в mindbox
     *
     * @param {Number} mindboxUserId Идентификатора пользователя в mindbox
     */
    getBonusBalance: function (mindboxUserId) {
        "use strict";

        return new Promise(function (resolve, reject) {
            let userBonusBalance = 0;
            if (mindboxUserId > 0) {
                // Создаем экземпляр класса XMLHttpRequest
                let request = new XMLHttpRequest();

                let formData = new FormData();

                formData.append("mindbox_user_id", mindboxUserId);

                request.open(
                    "POST",
                    "/ajax/user/get_mindbox_bonus_balance.php",
                    true
                );

                request.responseType = "json";

                request.send(formData);

                request.onload = function () {
                    if (request.readyState === 4 && request.status === 200) {
                        const jsonResponse = request.response;
                        if (jsonResponse.success && jsonResponse.mindboxBonusBalance) {
                            Personal.bonusBalance = jsonResponse.mindboxBonusBalance;
                            userBonusBalance = jsonResponse.mindboxBonusBalance;
                        }
                        resolve({"userBonusBalance": userBonusBalance});
                    } else {
                        // Запрос не выполнился
                        reject(new Error("Запрос не выполнился. " + request.status + ': ' + request.statusText));
                    }
                };
            } else {
                resolve({"userBonusBalance": userBonusBalance});
            }
        });
    },
    /**
     * Инициализация блока добавления карты лояльности
     */
    initLoyaltyCard: function () {
        "use strict";

        var loyaltyCardBlock = document.getElementById("loyaltyCard");
        var loyaltyCardBlockError = loyaltyCardBlock.querySelector(".error");
        var loyaltyCardBlockSuccess = loyaltyCardBlock.querySelector(".success");
        var linkCard = document.getElementById("linkCard");
        var loyaltyCard = document.getElementById("loyalty_card");
        var activationCode = document.getElementById("activation_code");
        var activationCodeButton = document.getElementById("activationCodeButton");
        var activationLoader = null;
        var resendLoader = null;
        var mindboxId = 0;
        var timer;

        loyaltyCard.oninput = function () {
            if (this.value.length > this.maxLength) {
                this.value = this.value.slice(0, this.maxLength);
            }
        };
        activationCode.oninput = function () {
            if (this.value.length > this.maxLength) {
                this.value = this.value.slice(0, this.maxLength);
            }
        };

        linkCard.addEventListener("click", linkCardClick);
        function linkCardClick(event) {
            if (!activationLoader) {
                activationLoader = "linkCard";
                let loader = window.BX.showWait(activationLoader);

                let request = new XMLHttpRequest();
                let formData = new FormData();
                if (!linkCard.classList.contains("sendCode")) {
                    /**
                     * Получение данных потребителя по номеру дисконтной карты
                     */
                    if (loyaltyCard.value.length === 12) {
                        event.preventDefault();

                        loyaltyCardBlockError.textContent = ""
                        loyaltyCardBlockError.style.display = "none";
                        formData.append("loyalty_card", loyaltyCard.value);
                        formData.append("sessid", loyaltyCardBlock.querySelector("#sessid").value);

                        request.open(
                            "POST",
                            "/ajax/mindBox/loyalty_card.php",
                            true
                        );
                        request.send(formData);
                        request.addEventListener(
                            "readystatechange",
                            function () {
                                if (request.readyState === 4 && request.status === 200) {
                                    var jsonResponse = JSON.parse(request.response);
                                    if (!!jsonResponse && jsonResponse.hasOwnProperty("success") && jsonResponse.success) {
                                        mindboxId = jsonResponse.mindboxId;
                                        loyaltyCardBlockSuccess.innerHTML = jsonResponse.message;
                                        loyaltyCardBlockSuccess.style.display = "block";

                                        document.getElementById("activationCode").style.display = "grid";
                                        linkCard.textContent = "Проверить код";
                                        linkCard.classList.add("sendCode");
                                        linkCardTimer();
                                        activationCodeButton.style.display = "block";
                                        loyaltyCard.disabled = true;

                                        activationCode.required = true;
                                    } else {
                                        loyaltyCardBlockError.textContent = jsonResponse.message;
                                        loyaltyCardBlockError.style.display = "block";
                                    }
                                    window.BX.closeWait(activationLoader, loader);
                                    activationLoader = null;
                                }
                            }
                        );
                    } else if (loyaltyCard.value.length > 0) {
                        event.preventDefault();
                        loyaltyCardBlockError.textContent = "Номер карты должен быть длиной 12 цифр.";
                        loyaltyCardBlockError.style.display = "block";
                    }
                } else {
                    /**
                     * Проверить код авторизации
                     */
                    if (activationCode.value.length === 4) {
                        event.preventDefault();

                        loyaltyCardBlockError.textContent = ""
                        loyaltyCardBlockError.style.display = "none";

                        formData.append("loyalty_card", loyaltyCard.value);
                        formData.append("activation_code", activationCode.value);
                        formData.append("mindboxId", mindboxId);
                        formData.append("sessid", loyaltyCardBlock.querySelector("#sessid").value);

                        request.open(
                            "POST",
                            "/ajax/mindBox/loyalty_card.php",
                            true
                        );
                        request.send(formData);
                        request.addEventListener(
                            "readystatechange",
                            function () {
                                if (request.readyState === 4 && request.status === 200) {
                                    var jsonResponse = JSON.parse(request.response);
                                    if (!!jsonResponse && jsonResponse.hasOwnProperty("success") && jsonResponse.success) {
                                        loyaltyCardBlockSuccess.innerHTML = jsonResponse.message;
                                        loyaltyCardBlockSuccess.style.display = "block";
                                        document.querySelector(".btn-loyalty-card").style.display = "none";
                                        loyaltyCardBlock.querySelectorAll(".grid-form").forEach(box => {box.style.display = "none"});
                                    } else {
                                        loyaltyCardBlockError.textContent = jsonResponse.message;
                                        loyaltyCardBlockError.style.display = "block";
                                    }
                                    window.BX.closeWait(activationLoader, loader);
                                    activationLoader = null;
                                }
                            }
                        );
                    } else {
                        event.preventDefault();
                        loyaltyCardBlockError.textContent = "Код активации должен быть длиной 4 цыфры.";
                        loyaltyCardBlockError.style.display = "block";
                    }
                }
            } else {
                event.preventDefault();
            }
        }

        activationCodeButton.addEventListener("click", activationCodeButtonClick);
        function activationCodeButtonClick(event) {
            event.preventDefault();
            var _this = this;
            if (_this.classList.contains("btn--disabled")) {
                _this.querySelector(".time-text").style.color = "red";
                setTimeout(function() {
                    _this.querySelector(".time-text").removeAttribute("style");
                }, 3000);
            } else {
                /**
                 * Переотправка кода подтверждения
                 */
                if (!resendLoader) {
                    resendLoader = "activationCodeButton";
                    var loader = window.BX.showWait(resendLoader);

                    loyaltyCardBlockError.textContent = ""
                    loyaltyCardBlockError.style.display = "none";
                    loyaltyCardBlockSuccess.textContent = ""
                    loyaltyCardBlockSuccess.style.display = "none";

                    var request = new XMLHttpRequest();
                    var formData = new FormData();
                    formData.append("mindboxId", mindboxId);
                    formData.append("sessid", loyaltyCardBlock.querySelector("#sessid").value);

                    request.open(
                        "POST",
                        "/ajax/mindBox/loyalty_card.php",
                        true
                    );
                    request.send(formData);
                    request.addEventListener(
                        "readystatechange",
                        function () {
                            if (request.readyState === 4 && request.status === 200) {
                                var jsonResponse = JSON.parse(request.response);
                                if (!!jsonResponse && jsonResponse.hasOwnProperty("success") && jsonResponse.success) {
                                    loyaltyCardBlockSuccess.innerHTML = jsonResponse.message;
                                    loyaltyCardBlockSuccess.style.display = "block";
                                    linkCardTimer();
                                } else {
                                    loyaltyCardBlockError.textContent = jsonResponse.message;
                                    loyaltyCardBlockError.style.display = "block";
                                }
                                window.BX.closeWait(resendLoader, loader);
                                resendLoader = null;
                            }
                        }
                    );
                }
            }
        }

        function linkCardTimer() {
            if (timer !== undefined) {
                clearInterval(timer);
            }
            activationCodeButton.classList.add("btn--disabled");
            activationCodeButton.querySelector('.time-text').style.display = "block";
            var codeResendTimeout = 30;
            timer = setInterval(function() {
                if (codeResendTimeout > 0) {
                    codeResendTimeout--;
                    var left, m, s;
                    left = codeResendTimeout;
                    m = Math.floor(left / 60);
                    left -= m * 60;
                    s = left;
                    activationCodeButton.querySelector(".span-time").textContent = ('0' + s).slice(-2);
                } else {
                    activationCodeButton.classList.remove("btn--disabled");
                    activationCodeButton.querySelector('.time-text').style.display = "none";
                    clearInterval(timer);
                }
            }, 1000);
        }
    }
}

export {
    Personal
}
